module.exports = __webpack_public_path__ + "img/dash-PROG-STANDARD_full_white.bdc1add8.png";